<template>
  <div>
    <v-expansion-panels accordion>
      <v-expansion-panel
        v-for="faq in faqs.filter(searchFaq)"
        :key="faq.id"
      >
        <v-expansion-panel-header v-if="faq.title[tab]">
          {{ faq.title[tab] }}
        </v-expansion-panel-header>
        <v-expansion-panel-content v-if="faq.title[tab]">
          <div v-html="faq.text[tab]" />
          Category: {{ faq.category.name }}<br>
          Hashtag: {{ faq.hashtag }}<br>
          <span v-if="tab === 3 && faq.gitlabLink">
            Gitlab Link: {{ faq.gitlabLink }}<br>
          </span>
          Date: {{ faq.date }}<br>
          <br>
          <div style="text-align:right">
            <v-icon
              color="green darken-2"
              class="mr-5"
              @click="editFaq(faq)"
            >
              mdi-square-edit-outline
            </v-icon>
            <v-icon
              color="red darken-2"
              class="mr-2"
              @click="deleteItem(faq.id)"
            >
              mdi-trash-can-outline
            </v-icon>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog
      v-model="showEditDialog"
      persistent
      max-width="1000px"
    >
      <v-card class="pb-3 pt-2">
        <v-tabs
          v-model="editTab"
        >
          <v-tab>
            <v-icon
              v-if="isFormValid[0]"
              color="green"
            >
              mdi-check
            </v-icon>
            {{ $t('faq.tabger') }}
          </v-tab>
          <v-tab>
            <v-icon
              v-if="isFormValid[1]"
              color="green"
            >
              mdi-check
            </v-icon>
            {{ $t('faq.taben') }}
          </v-tab>
          <v-tab>
            <v-icon
              v-if="isFormValid[2]"
              color="green"
            >
              mdi-check
            </v-icon>
            {{ $t('faq.tabes') }}
          </v-tab>
          <v-tab>
            <v-icon
              v-if="isFormValid[3]"
              color="green"
            >
              mdi-check
            </v-icon>
            {{ $t('faq.tabdev') }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="editTab">
          <v-tab-item>
            <v-form>
              <v-container class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="title[editTab]"
                      class="purple-input"
                      :label="$t('faq.question')"
                      @input="validateForm"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <tiptap-vuetify
                      v-model="text[editTab]"
                      :extensions="tiptapExtensions"
                      :card-props="{ flat: true }"
                      @input="validateForm"
                    >
                      <template #toolbar-before>
                        <div class="tiptapHeader">
                          {{ $t('faq.answer') }}
                        </div>
                      </template>
                    </tiptap-vuetify>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form>
              <v-container class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="title[editTab]"
                      class="purple-input"
                      label="Title"
                      @input="validateForm"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <tiptap-vuetify
                      v-model="text[editTab]"
                      :extensions="tiptapExtensions"
                      :card-props="{ flat: true }"
                      @input="validateForm"
                    >
                      <template #toolbar-before>
                        <div class="tiptapHeader">
                          {{ $t('faq.answer') }}
                        </div>
                      </template>
                    </tiptap-vuetify>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form>
              <v-container class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="title[editTab]"
                      class="purple-input"
                      :label="$t('faq.question')"
                      @input="validateForm"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <tiptap-vuetify
                      v-model="text[editTab]"
                      :extensions="tiptapExtensions"
                      :card-props="{ flat: true }"
                      @input="validateForm"
                    >
                      <template #toolbar-before>
                        <div class="tiptapHeader">
                          {{ $t('faq.answer') }}
                        </div>
                      </template>
                    </tiptap-vuetify>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form>
              <v-container class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="title[editTab]"
                      class="purple-input"
                      :label="$t('faq.question')"
                      @input="validateForm"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="gitlabLink"
                      class="purple-input"
                      label="Gitlab Issue Link"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <tiptap-vuetify
                      v-model="text[editTab]"
                      :extensions="tiptapExtensions"
                      :card-props="{ flat: true }"
                      @input="validateForm"
                    >
                      <template #toolbar-before>
                        <div class="tiptapHeader">
                          {{ $t('faq.answer') }}
                        </div>
                      </template>
                    </tiptap-vuetify>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
        <v-form>
          <v-container class="py-0">
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-combobox
                  v-model="category"
                  :items="availableCategories"
                  :label="$t('faq.category')"
                  item-text="name"
                  item-value="id"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-combobox
                  v-model="hashtag"
                  :items="availableHashtag"
                  :label="$t('faq.hashtag')"
                  multiple
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="text-right"
              >
                <v-menu
                  ref="dateMenu"
                  v-model="showDatePicker"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      :label="$t('faq.date')"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="date"
                    no-title
                    scrollable
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      @click="showDatePicker = false"
                    >
                      {{ $t('faq.cancel') }}
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dateMenu.save(date)"
                    >
                      {{ $t('faq.save') }}
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  class="purple-input"
                  :label="$t('faq.id')"
                  readonly
                  :value="id"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              @click="clearForm"
            >
              {{ $t('faq.cancel') }}
            </v-btn>
            <v-btn
              color="green darken-1"
              :disabled="isSaveButtonDisabled"
              @click="saveFaq"
            >
              {{ $t('faq.save') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History, Image, CodeBlock } from 'tiptap-vuetify'
  import { deleteFaq, writeFaq } from '@/firebase'
  import uploadImage from '../modals/uploadImage'

  export default {
    name: 'Faq',
    components: { TiptapVuetify },
    props: ['faqs', 'tab', 'searchText'],
    data: () => ({
      showEditDialog: false,
      editTab: 0,
      title: ['', '', '', ''],
      text: ['', '', '', ''],
      gitlabLink: '',
      ts: '',
      date: new Date().toISOString().substr(0, 10),
      id: '',
      category: {},
      availableCategories: [
        { name: 'Basic Info', id: 'basic' },
        { name: 'Application', id: 'app' },
        { name: 'Tech Question', id: 'tech' },
        { name: 'Privacy/Information Security', id: 'privacy' },
      ],
      hashtag: [],
      availableHashtag: [],
      isFormValid: [],
      isSaveButtonDisabled: true,
      showDatePicker: false,
      showSnackbar: false,
      tiptapExtensions: [
        History,
        Blockquote,
        Link,
        [Image, {
          options: {
            imageSourcesOverride: true,
            imageSources: [
              { component: uploadImage, name: 'Upload Image' },
            ],
          },
        }],
        Bold,
        Italic,
        Underline,
        Strike,
        ListItem,
        BulletList,
        OrderedList,
        [Heading, {
          options: {
            levels: [1, 2, 3],
          },
        }],
        Code,
        CodeBlock,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
    }),
    mounted () {
      this.validateForm()
    },
    methods: {
      searchFaq (faq) {
        if (this.searchText) {
          if (faq.title[this.tab]) {
            if (faq.title[this.tab].search(this.searchText) !== -1) {
              return true
            }
          }
          if (faq.text[this.tab]) {
            if (faq.text[this.tab].search(this.searchText) !== -1) {
              return true
            }
          }
          return false
        }
        return true
      },
      editFaq (faq) {
        this.showEditDialog = true
        this.title = faq.title
        this.text = faq.text
        this.gitlabLink = faq.gitlabLink
        this.ts = Date.now()
        this.date = new Date().toISOString().substr(0, 10)
        this.id = faq.id
        this.category = faq.category
        this.hashtag = faq.hashtag
        this.validateForm()
      },
      deleteItem (id) {
        deleteFaq(id)
          .then(() => {
            this.$emit('request-load-faqs')
          })
          .catch(error => {
            console.log(error)
          })
      },
      saveFaq () {
        if ((this.isFormValid[0] && this.isFormValid[1] && this.isFormValid[2]) || this.isFormValid[3]) {
          const payload = {
            title: this.title,
            text: this.text,
            gitlabLink: this.gitlabLink,
            ts: this.ts,
            date: this.date,
            id: this.id,
            category: this.category,
            hashtag: this.hashtag,
          }
          console.log(payload)
          writeFaq(payload)
            .then(() => {
              this.snackbarMessage = 'FAQ saved'
              this.showSnackbar = true
              this.clearForm()
              this.$emit('request-load-faqs')
            })
            .catch(error => {
              console.log(error)
            })
        }
      },
      clearForm () {
        this.title = ['', '', '', '']
        this.text = ['', '', '', '']
        this.gitlabLink = ''
        this.ts = Date.now()
        this.date = new Date().toISOString().substr(0, 10)
        this.id = ''
        this.category = { name: 'Basic Info', id: 'basic' }
        this.hashtag = []
        this.validateForm()
        this.showEditDialog = false
      },
      validateForm () {
        for (let i = 0; i < 4; i++) {
          if (this.title[i] && this.text[i]) {
            this.isFormValid[i] = true
          } else {
            this.isFormValid[i] = false
          }
        }
        if ((this.isFormValid[0] && this.isFormValid[1] && this.isFormValid[2]) || this.isFormValid[3]) {
          this.isSaveButtonDisabled = false
        } else {
          this.isSaveButtonDisabled = true
        }
      },
    },
  }
</script>

<style lang="scss">
  .tiptapHeader {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.3);
  margin-bottom: 5px;
}
</style>
